import React from "react";
import Switch from "react-switch";

export default function Toggle({ defaultAM, onHandleToggle }) {
  return (
    <div className="switch-label" id="toggle-container">
      <p className="switch-label-am" id="toggle-title-am">
        AM
      </p>
      <Switch
        onChange={() => onHandleToggle()}
        checked={defaultAM}
        uncheckedIcon={false}
        checkedIcon={false}
        offColor={"#35a3dc"}
        onColor={"#35a3dc"}
        className="switch"
        id="switch-am-pm"
      />
      <p className="switch-label-pm" id="toggle-title-pm">
        PM
      </p>
    </div>
  );
}
